<template>
    <div class="buttons level-item">
        <button
            v-for="option in options"
            :key="option"
            :class="{
                'is-primary has-text-weight-bold': option == filter,
                'is-light': option != filter,
            }"
            class="lb-button is-capitalized"
            @click="$emit('update:filter', option)"
        >
            {{ option }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        filter: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            required: true,
            default() {
                return [];
            },
        },
    },
};
</script>

<style scoped>
.lb-button {
    font-weight: 400 !important;
}
.lb-button.has-text-weight-bold {
    font-weight: 700 !important;
}
</style>
